import React, { useState } from 'react';
import { Link } from 'react-router';
import { clsx } from 'clsx';

// UI
import Button from '@components/button';

// assets
import logoImg from '@assets/new-logo-landing.svg';
import FbIcon from './icons/fb.svg?react';
import InIcon from './icons/in.svg?react';
import YtIcon from './icons/yt.svg?react';

// styles
import css from './styles.module.css';

interface HeaderProps {
  onMenuToggle?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuToggle }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    onMenuToggle?.();
  };

  const menuItems = [
    { href: '/#product', text: 'Product' },
    { href: '/#pricing', text: 'Pricing' },
    { href: '/#help', text: 'Help center' },
    { href: '/blog', text: 'Blog' },
  ];

  return (
    <header className={css.header}>
      <div className={css.wrapper}>
        <a href="https://turbopush.io/" className={css.logo}>
          <img src={logoImg} alt="Loyalty cards" width={270} height="auto" />
        </a>

        <div
          className={`${css.overlay} ${isMenuOpen ? css.active : ''}`}
          onClick={toggleMenu}
        />

        <div className={clsx(css.menu, css.desktopMenu)}>
          <ul className={css.menuList}>
            {menuItems.map((item) => (
              <li key={item.text} className={css.menuItem}>
                <Link
                  to={item.href}
                  className={css.menuLink}
                  onClick={toggleMenu}
                >
                  {item.text}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className={`${css.content} ${isMenuOpen ? css.active : ''}`}>
          <div className={`${css.menu} ${css.menuMobile}`}>
            <ul className={css.menuList}>
              {menuItems.map((item) => (
                <li key={item.text} className={css.menuItem}>
                  <Link
                    to={item.href}
                    className={css.menuLink}
                    onClick={toggleMenu}
                  >
                    {item.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className={css.buttons}>
            <Link to="/login">
              <Button size="large">Log in / Register</Button>
            </Link>
          </div>

          <ul className={css.socials}>
            {/* {['in', 'fb', 'yt'].map((platform) => (
              <li key={platform} className={css.socialsItem}>
                <a href="">
                  <i
                    className={clsx(css.icon, { [css[platform]]: platform })}
                  />
                </a>
              </li>
            ))}  */}

            <li className={css.socialsItem}>
              <a href="">
                {/* <i className={clsx(css.icon, { [css[platform]]: platform })} /> */}
                <FbIcon className={css.icon} />
              </a>
            </li>

            <li className={css.socialsItem}>
              <a href="">
                {/* <i className={clsx(css.icon, { [css[platform]]: platform })} /> */}
                <InIcon className={css.icon} />
              </a>
            </li>

            <li className={css.socialsItem}>
              <a href="">
                {/* <i className={clsx(css.icon, { [css[platform]]: platform })} /> */}

                <YtIcon className={css.icon} />
              </a>
            </li>
          </ul>
        </div>

        <button
          className={clsx(css.btn, css.burgerBtn, { [css.active]: isMenuOpen })}
          type="button"
          onClick={toggleMenu}
        >
          <span />
        </button>
      </div>
    </header>
  );
};

export default Header;
